import React, { memo } from "react";
import { FaCircle } from "react-icons/fa";
import { IoPrintOutline } from "react-icons/io5";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import styles from "../table.module.scss";
import DropdownButton from "./DropdownButton";
const TableBody = ({
  tableBody,
  tableHead,
  canView,
  handleShare,
  handleShowGlobalViewModal,
  handleEdit,
  handleDelete,
  handlePermission,
  handleCheckboxChange,
  checkedItems,
  handleStatusSelect,
  showStatus,
  toggleStatus,
  redirectReferrerPaymentPage,
  openTransactionModal,
  canEdit,
  canDelete,
  canExport,
  handlePrint,
  showPrintButton,
  handelProfile,
  handleRefund,
  handleCancel,
}) => {
  return (
    <tbody>
      {tableBody &&
        tableBody?.map((item, ind) => {
          const canPrint = item?.status === "final";

          return (
            <tr
              key={ind}   
              onClick={() =>
                canView &&
                handleShowGlobalViewModal &&
                handleShowGlobalViewModal(item)
              }
            >
              {handleCheckboxChange && (
                <td onClick={(e) => e.stopPropagation()}>
                  <div className="form-check custom-checkbox checkbox-success check-lg me-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`check_${item.id}`}
                      checked={
                        item.paymentStatus === "PAID"
                          ? true
                          : checkedItems[item.id] || false
                      }
                      onChange={() => handleCheckboxChange(item.id)}
                      style={{ backgroundColor: "#fff" }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`check_${item.id}`}
                    ></label>
                  </div>
                </td>
              )}

              {tableHead &&
                tableHead?.map((head, i) => (
                  <td key={i} style={{ cursor: "pointer" }}>
                    {head?.title !== "Status" ? (
                      item[head.key] !== null &&
                      item[head.key] !== undefined ? (
                        item[head.key]?.length > 35 ? (
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="auto"
                            overlay={
                              <Tooltip  className="d-flex align-items-center justify-content-center">
                                <p
                                  className="popover-header"
                                  style={{
                                    marginBottom: 0,
                                    fontSize: "0.85rem",
                                  }}
                                >
                                  {item[head.key]}
                                </p>
                              </Tooltip>
                            }
                          >
                            <span>{item[head.key]?.substring(0, 35)+ "..."}</span>
                          </OverlayTrigger>
                        ) : (
                          item[head.key]
                        )
                      ) : (
                        "N/A"
                      )
                    ) : (
                      <div
                        className="position-relative"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div
                          className="d-flex align-items-center cursor-pointer"
                          onClick={() => toggleStatus(ind)}
                        >
                          {["Active", "Inactive", "Deleted"].includes(
                            item[head?.key],
                          ) && (
                             <FaCircle
                            className={
                              item[head?.key] === "Active"
                                ? "text-success me-1"
                                : item[head?.key] === "Inactive"
                                ? "text-warning me-1"
                                : item[head?.key] === "Deleted"
                                ? "text-danger me-1"
                                : "text-warning me-1"
                            }
                          />
                          )}
                         <span
                          style={{
                            fontWeight: ["PAID", "UNPAID"].includes(
                              item[head?.key]
                            )
                              ? "bold"
                              : "normal",
                            color:
                              item[head?.key] === "PAID"
                                ? "#2bc155"
                                : item[head?.key] === "UNPAID"
                                ? "#ffb800"
                                : "inherit",
                          }}
                        >
                          {item[head?.key]?.toUpperCase()}
                        </span>
                      </div>

                         {showStatus === ind && (
                        <div className={styles.statusWrapper}>
                          {["Active", "Inactive", "Deleted"].map((status) => (
                            <div
                              key={status}
                              className={styles.status}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleStatusSelect(status, item);
                              }}
                            >
                              <FaCircle
                                size={15}
                                className={`me-1 ${
                                  status === "Active"
                                    ? "text-success"
                                    : status === "Inactive"
                                    ? "text-warning"
                                    : "text-danger"
                                }`}
                              />
                              {status}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </td>
              ))}
              {(handleShowGlobalViewModal ||
                handleCancel ||
                handleEdit ||
                handleDelete ||
                handlePermission) && (
                <td
                  className={styles.actionColumn}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                    }}
                  >
                      <DropdownButton
                  item={item}
                  canView={canView}
                  canEdit={canEdit}
                  canDelete={canDelete}
                  canExport={canExport}
                  handleShowGlobalViewModal={handleShowGlobalViewModal}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                  handlePermission={handlePermission}
                  handlePrint={handlePrint}
                  handlePrint={!showPrintButton ? handlePrint : null}
                  handleShare={handleShare}
                  handelProfile={handelProfile}
                  handleRefund={handleRefund}
                  handleCancel={handleCancel}
                />
                    {showPrintButton && handlePrint && (
                      <div
                        style={{
                          cursor: canPrint ? "pointer" : "not-allowed",
                          opacity: canPrint ? 1 : 0.5,
                        }}
                        onClick={() => {
                          if (canPrint) {
                            handlePrint(item);
                          }
                        }}
                      >
                        <IoPrintOutline size={20} />
                      </div>
                    )}
                  </div>
                </td>
              )}

              {redirectReferrerPaymentPage && (
                <td className="d-flex align-items-center" onClick={(e) => e.stopPropagation()}>
                  <p
                    className={styles.paymentHistory}
                    onClick={() => redirectReferrerPaymentPage(item)}
                  >
                    Payment History
                  </p>
                </td>
              )}
            </tr>
          );
        })}
    </tbody>
  );
};
export default memo(TableBody);